import './style.scss';

export function company_updates_block() {
    const block = document.querySelector('.company_updates_block');
    if (!block) return;

}
